// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Link, Typography } from '@iheartjane/reefer';

export const InlineLink = styled(Link)(({ theme }) => ({
  color: theme.colors.text.light,
  display: 'inline',
}));

export const InlineBlockTypography = styled(Typography)(({ theme }) => ({
  color: theme.colors.text.light,
  display: 'inline-block',
}));
